var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuOurServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5652 11.0051L10.0073 17.5L3.44952 11.0051C3.01697 10.5842 2.67625 10.0783 2.44883 9.51925C2.22141 8.96019 2.11221 8.3601 2.1281 7.75676C2.144 7.15343 2.28464 6.55992 2.54118 6.01361C2.79771 5.4673 3.16459 4.98002 3.6187 4.58247C4.0728 4.18491 4.60431 3.88568 5.17974 3.70363C5.75517 3.52158 6.36207 3.46065 6.96221 3.52467C7.56235 3.58868 8.14273 3.77627 8.66681 4.07561C9.19089 4.37496 9.64732 4.77957 10.0073 5.26397C10.3689 4.78309 10.8259 4.38201 11.3496 4.08584C11.8733 3.78968 12.4525 3.6048 13.051 3.54278C13.6494 3.48076 14.2543 3.54294 14.8276 3.72541C15.4009 3.90789 15.9304 4.20674 16.3829 4.60326C16.8354 4.99978 17.2012 5.48544 17.4574 6.02983C17.7136 6.57423 17.8546 7.16564 17.8718 7.76706C17.8889 8.36848 17.7817 8.96695 17.5568 9.52503C17.332 10.0831 16.9944 10.5888 16.5652 11.0104M10.0073 5.25879L7.12794 8.13811C6.96402 8.30208 6.87194 8.52444 6.87194 8.75629C6.87194 8.98815 6.96402 9.21051 7.12794 9.37448L7.60273 9.84926C8.20605 10.4526 9.18535 10.4526 9.78867 9.84926L10.663 8.97489C11.1848 8.45312 11.8925 8.15999 12.6304 8.15999C13.3683 8.15999 14.076 8.45312 14.5977 8.97489L16.5651 10.9422M10.4445 13.5654L12.1932 15.3141M12.6304 11.3794L14.3792 13.1282",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOurServiceIcon);
export default __webpack_public_path__ + "static/media/menu-our-service-icon.f8c18d8c96eecbee2c1127561b31e98a.svg";
export { ForwardRef as ReactComponent };